import { useState } from "react";
import Dropzone from "react-dropzone";

export default function ImportMediaDropzoneV2({
  onFileSelected,
  acceptedType,
}) {
  const [error, setError] = useState(null);

  return (
    <div>
      <Dropzone
        onDrop={(acceptedFiles) => {
          const file = acceptedFiles?.[0];
          if (file) {
            onFileSelected(file); // << pass the File directly
          } else {
            setError("Could not upload file, please try again.");
          }
        }}
        accept={acceptedType}
        maxFiles={1}
        multiple={false}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <button
              type="button"
              className="rounded-md bg-gray-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
            >
              Upload
            </button>
          </div>
        )}
      </Dropzone>

      {error && (
        <div className="text-center p-4">
          <h3 className="text-lg leading-6 font-normal text-red-500">
            {error}
          </h3>
        </div>
      )}
    </div>
  );
}
